import { useMemo } from "react";

const BLOCK = "\u2588";

/**
 * Renders copy where runs of █ become true redaction bars.
 * Keeps the surrounding words readable so the fragment still reads as a sentence.
 */
export const RedactedText = ({ text, className = "", tone = "light" }) => {
  const tokens = useMemo(() => {
    if (!text) return [];
    return text.split(new RegExp(`(${BLOCK}+)`, "g")).filter(Boolean);
  }, [text]);

  const barClass = tone === "ink" ? "redact redact-ink" : "redact";

  return (
    <span className={className}>
      {tokens.map((tok, i) =>
        tok.startsWith(BLOCK) ? (
          <span
            key={i}
            className={barClass}
            aria-label="redacted"
            title="Redacted"
          >
            {tok}
          </span>
        ) : (
          <span key={i}>{tok}</span>
        )
      )}
    </span>
  );
};

/** A run of pure redaction bars, useful as filler in locked cards. */
export const RedactionLines = ({ widths = ["92%", "78%", "86%", "54%"], tone = "light" }) => (
  <div className="space-y-2" aria-hidden="true">
    {widths.map((w, i) => (
      <div
        key={i}
        className={`h-[0.72rem] rounded-sm ${
          tone === "ink"
            ? "bg-[hsl(220_18%_10%)] opacity-95"
            : "bg-[hsl(210_18%_88%)] opacity-90"
        }`}
        style={{ width: w }}
      />
    ))}
  </div>
);
